import { applyInputMask, maskInputSlotCount, parseMaskPattern } from "./input-mask";
import { getDateTimeFormat } from "@/lib/intl-date/formatters";
const REFERENCE_DATE = new Date(2001, 8, 3);
function getNumericPartOrder(locale) {
  return getDateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(REFERENCE_DATE).filter(part => part.type === "year" || part.type === "month" || part.type === "day").map(part => part.type);
}
export function buildDateMaskPattern(locale) {
  const parts = getDateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(REFERENCE_DATE);
  let pattern = "";
  for (const part of parts) {
    if (part.type === "literal") {
      pattern += part.value;
      continue;
    }
    if (part.type === "month" || part.type === "day" || part.type === "year") {
      pattern += part.value.replace(/\d/g, "0");
    }
  }
  return pattern;
}
export function getDefaultDatePlaceholder(locale) {
  const parts = getDateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(REFERENCE_DATE);
  return parts.map(part => {
    if (part.type === "literal") {
      return part.value;
    }
    if (part.type === "year") {
      return "yyyy";
    }
    if (part.type === "month") {
      return "mm";
    }
    if (part.type === "day") {
      return "dd";
    }
    return "";
  }).join("");
}
export function extractMaskDigits(value) {
  return value.replace(/\D/g, "");
}
export function applyDateMask(digits, pattern) {
  return applyInputMask(extractMaskDigits(digits), pattern);
}
export function maskDigitCapacity(pattern) {
  return maskInputSlotCount(parseMaskPattern(pattern), {
    requiredOnly: true
  });
}
function normalizeYear(value) {
  if (value >= 100) {
    return value;
  }
  return value >= 69 ? 1900 + value : 2e3 + value;
}
export function maskedDigitsToParts(digits, locale) {
  const order = getNumericPartOrder(locale);
  let cursor = 0;
  const values = {};
  for (const type of order) {
    const width = type === "year" ? 4 : 2;
    const slice = digits.slice(cursor, cursor + width);
    if (slice.length < width) {
      return null;
    }
    let numeric = Number(slice);
    if (type === "year") {
      numeric = normalizeYear(numeric);
    }
    values[type] = numeric;
    cursor += width;
  }
  return values;
}
export function partsToDate(parts) {
  if (parts.year == null || parts.month == null || parts.day == null) {
    return null;
  }
  const date = new Date(parts.year, parts.month - 1, parts.day);
  if (date.getFullYear() !== parts.year || date.getMonth() !== parts.month - 1 || date.getDate() !== parts.day) {
    return null;
  }
  return date;
}
export { getNumericPartOrder };